import React from "react";
import PrivacyPolicyTemplate from "../components/templates/PrivacyPolicyTemplate";

const PrivacyPolicy = () => {
	return <PrivacyPolicyTemplate />;
};

export default PrivacyPolicy;
